// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__22oyp","amount":"Amount_amount__1ipDJ","tip":"Amount_tip__1xFQb","tipHeader":"Amount_tipHeader__1l3Xp","tipsWrap":"Amount_tipsWrap__OlS5v"};